<header class="header-area d-flex align-items-center justify-content-space-between">
  <a routerLink="/" class="brand-link d-flex align-items-center" title="My Library">
    @if (!isLogoAvatar) {
      <span class="logo-chip d-flex align-items-center justify-content-center">
        <img src="assets/img/logo-icon.png" alt="" />
      </span>
      <span class="ms-10 fs-16 fw-semibold wordmark">Peech</span>
    }
  </a>

  <!-- min-w-0: a private-relay email as display name must shrink, not widen the header. -->
  <div class="header-right-side d-flex align-items-center mt-0 mb-0 min-w-0">
    <button
      [matMenuTriggerFor]="profileMenu"
      class="profile-btn border-none bg-transparent position-relative d-flex align-items-center gap-8 min-w-0 cursor-pointer"
    >
      @if (isLoggedIn) {
        <img src="{{ avatarUrl }}" class="rounded-circle" alt="user" (error)="onAvatarError()" />
      }
      @if (!isLoggedIn) {
        <div class="user-icon ri-user-3-fill"></div>
      }
      @if (isLoggedIn) {
        <!-- Clipped with an ellipsis when long, so keep the full value reachable on hover. -->
        <span class="fs-14 fw-medium text-truncate min-w-0" [title]="name">{{ name }}</span>
      }
      <i class="ri-arrow-down-s-line muted-color"></i>
    </button>
    <mat-menu class="app-menu-panel" #profileMenu="matMenu" xPosition="before">
      @if (!isLoggedIn) {
        <a mat-menu-item routerLink="/authentication/login">
          <i class="ri-user-3-line"></i> Log In
        </a>
      }
      @if (isLoggedIn && !isAccountPage) {
        <a mat-menu-item routerLink="/account"> <i class="ri-user-3-line"></i> Profile </a>
      }
      @if (isLoggedIn) {
        <a mat-menu-item routerLink="/"> <i class="ri-book-shelf-line"></i> Library </a>
      }
      @if (isLoggedIn) {
        <a mat-menu-item routerLink="/authentication/logout">
          <i class="ri-shut-down-line"></i> Logout
        </a>
      }
    </mat-menu>
  </div>
</header>
